import store from '@/store/index.js';

const setShape = function (circle = null, polygon = null, selectedTab = null, mapId = null, dataLayer = null, keepMarkers = false) {
  if (circle || polygon || dataLayer) {
    store.dispatch('comparablesModule/setComparableSearchZone', { circle, polygon, dataLayer, selectedTab });
    if (!keepMarkers) setMarkers([], mapId);
    setCircles([], mapId);
    setPolygons([], mapId);
    setDataLayers([], mapId);

    if (circle) {
      setCircles(circle, mapId);
    }

    if (polygon) {
      setPolygons(polygon, mapId);
    }

    if (dataLayer) {
      setDataLayers(dataLayer, mapId);
    }
  }
};

const setMarkers = function (markers, mapId) {
  store.dispatch('pixMapModule/setMarkers', { mapId, markers });
};

const setCircles = function (circle, mapId) {
  const circles = Array.isArray(circle) ? circle : [circle];
  store.dispatch('pixMapModule/setCircles', {
    mapId,
    circles,
  });
};

const setPolygons = function (polygon, mapId) {
  const polygons = Array.isArray(polygon) ? polygon : [polygon];
  store.dispatch('pixMapModule/setPolygons', {
    mapId,
    polygons,
  });
};

const setDataLayers = function (dataLayer, mapId) {
  const dataLayers = Array.isArray(dataLayer) ? dataLayer : [dataLayer];
  store.dispatch('pixMapModule/setDataLayers', {
    mapId,
    dataLayers,
  });
};

const isWktSimplePolygon = function (wkt) {
  /* We use geometryCollections as simplePolygons because they work in the same way */
  return wkt.substring(0, wkt.indexOf('('))?.toLowerCase().trim() === 'polygon' || isGeometryCollection(wkt);
};

const isWktMultiPolygon = function (wkt) {
  return wkt.substring(0, wkt.indexOf('('))?.toLowerCase().trim() === 'multipolygon';
};

const isGeometryCollection = function (wkt) {
  return wkt.substring(0, wkt.indexOf('('))?.toLowerCase().trim() === 'geometrycollection';
};

/**
 * @param {String} coordinatesString A string containing coordinates following this pattern 'POLYGON('23.3434, -56.23131231, 32.45433543')...
 * @returns an array of { lat, lng } pairs containing the coordinatesString parsed values
 */
const getPolygonCoordinates = function (coordinatesString) {
  const isPolygon = isWktSimplePolygon(coordinatesString);
  const isMultipolygon = isWktMultiPolygon(coordinatesString);
  if (isPolygon) {
    return getSimplePolygonCoordinates(coordinatesString);
  } else if (isMultipolygon) {
    return getMultipolygonCoordinates(coordinatesString);
  } else {
    console.error('Array of coordinates not a polygon nor a multipolygon');
    return null;
  }
};

const getSimplePolygonCoordinates = function (coordinatesString) {
  const arrayOfCoordinates = coordinatesString.substring(coordinatesString.lastIndexOf('(') + 1, coordinatesString.lastIndexOf(')') + 1);
  const splittedCoordinates = arrayOfCoordinates.split(', ');
  const coordinates = splittedCoordinates.map((coordinate) => {
    let [lng, lat] = coordinate.split(' ');
    lng = parseFloat(lng);
    lat = parseFloat(lat);
    return { lng, lat };
  });
  coordinates.pop();
  return coordinates;
};

// Editted from https://github.com/jmilagroso/multipolygon-to-js-array/blob/master/index.js
const getMultipolygonCoordinates = function (coordinatesString) {
  const plainCoordinatesString = coordinatesString.replace('MULTIPOLYGON (((', '').replace('MULTIPOLYGON(((', '').replace(')))', '))');
  const polygonsStringArray = plainCoordinatesString.split('((');
  return polygonsStringArray.map((polygonString) => {
    const polygonCoordinatesString = polygonString.replace(')),', '').replace('))', '').split(',');
    return polygonCoordinatesString.map((coordinateString) => {
      let [lng, lat] = coordinateString.trim().split(' ');
      lng = parseFloat(lng);
      lat = parseFloat(lat);
      return { lng, lat };
    });
  });
};

const getPolygonArrayCenter = function (polygons) {
  const polygonCenters = polygons.map((a) => getPolygonCenter(a.coordinates));
  return getPolygonCenter(polygonCenters);
};

const getPolygonCenter = function (coordinatesArray) {
  let lowestX = coordinatesArray[0].lat;
  let lowestY = coordinatesArray[0].lng;
  let highestX = coordinatesArray[coordinatesArray.length - 1].lat;
  let highestY = coordinatesArray[coordinatesArray.length - 1].lng;
  coordinatesArray.forEach(function (point) {
    lowestX = point.lat < lowestX ? point.lat : lowestX;
    lowestY = point.lng < lowestY ? point.lng : lowestY;
    highestX = point.lat > highestX ? point.lat : highestX;
    highestY = point.lng > highestY ? point.lng : highestY;
  });
  return {
    lat: lowestX + (highestX - lowestX) / 2,
    lng: lowestY + (highestY - lowestY) / 2,
  };
};

export default {
  getPolygonCoordinates,
  getPolygonCenter,
  setShape,
  setMarkers,
  isWktSimplePolygon,
  isWktMultiPolygon,
  getPolygonArrayCenter,
};
